const arr = [
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon1.png',
    name: '档案管理',
    desc: '22',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-1.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major2Img-1.png',
  },
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon2.png',
    name: '授课规划',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-2.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major2Img-2.png',
  },
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon3.png',
    name: '试听体验',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-3.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major2Img-3.png',
  },
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon4.png',
    name: '授课场景',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-4.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major2Img-4.png',
  },
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon5.png',
    name: '资料分析',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-5.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-5.png',
  },
  {
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/icon6.png',
    name: '督学陪伴',
    major1Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-6.png',
    major2Img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/major1Img-6.png',
  },
];
export default arr;
